import * as actionTypes from "./types";

/**
 * Recupère les données pour la page admin des clients
 * @param  {int} establishmentId
 */
export const initPage = (establishmentId) => ({
  type: actionTypes.INIT_ADMIN_STORE_CUSTOMERS,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/customers.json`,
    method: "GET",
    params: {
      establishment: establishmentId,
    }
  }
});

/**
 * Recupère les infos d'un client store sans les commandes
 */
export const getStoreCustomerInfo = (customer) => ({
  type: actionTypes.GET_STORE_CUSTOMER_INFO,
  payload: {
    customer: customer,
  }
});

/**
 * Recupère le détail d'un seul client store (mêmes champs que la liste)
 * Utile là où la liste complète des clients n'est pas chargée (intendance charrette)
 */
export const getStoreCustomerDetail = (customerId) => ({
  type: actionTypes.GET_STORE_CUSTOMER_DETAIL,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/customers/${customerId}.json`,
    method: "GET",
  },
});

/**
 * Recupère les données de commande d'un client store
 */
export const getStoreCustomerOrders = (customer) => ({
  type: actionTypes.GET_STORE_CUSTOMER_ORDERS,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/customers/${customer.id}/orders.json`,
    method: "GET",
  },
  payload: {
    customer: customer,
  }
});

/**
 * Recupère l'historique unifié des transactions bancaires d'un client (PayGreen + Edenred)
 * @param {int} customerId
 * @param {int} days profondeur de l'historique en jours
 * @param {bool} nocache force le rafraîchissement (le volet PayGreen est mis en cache 1 min côté API)
 */
export const getStoreCustomerTransactions = (customerId, days = 90, nocache = false) => ({
  type: actionTypes.GET_STORE_CUSTOMER_TRANSACTIONS,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/customers/${customerId}/transactions.json`,
    method: "GET",
    params: nocache ? { days: days, nocache: 1 } : { days: days },
  },
  payload: {
    customerId: customerId,
    days: days,
  },
});

/**
 * Permet de mettre à jour les données d'un client
 */
export const updateStoreCustomer = (customer) => ({
  type: actionTypes.UPDATE_STORE_CUSTOMER,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/store/customers/${customer.id}.json`,
    method: "PUT",
    body: {
      ...customer
    }
  },
});

/**
 * Permet d'ajouter un client
 * Par défaut, on ajoute le créé par l'admin et pour le mode kiosque car l'action existe justement pour le mode kiosque
 */
export const addStoreCustomer = (data) => ({
  type: actionTypes.POST_STORE_CUSTOMER,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/customers/customers.json`,
    method: "POST",
    body: {...data, createdByAdmin: true, createdForKiosk: true}
  },
});

export const sendCodeBySMS = (customer) => ({
  type: actionTypes.STORE_CUSTOMER_SEND_CODE_BY_SMS,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/customers/sendcodebysms.json`,
    method: "POST",
    body: {
      customerId: customer.id
    },
  },
});

/**
 * Génère un lien de nouveau mot de passe (valable 24 h) à copier pour un client.
 */
export const createPasswordResetLink = (customerId) => ({
  type: actionTypes.STORE_CUSTOMER_PASSWORD_RESET_LINK,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/customers/${customerId}/password-reset-link.json`,
    method: "POST",
    body: {},
  },
});

/**
 * Rembourse (totalement) un paiement PayGreen d'une commande
 */
export const refundOrderPayment = (customerId, orderId, paymentId) => ({
  type: actionTypes.REFUND_ORDER_PAYMENT,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/customers/${customerId}/orders/${orderId}/payments/${paymentId}/refund.json`,
    method: "POST",
    body: {},
  },
});

/**
 * Annule l'utilisation des avantages (cagnotte) d'une commande et re-crédite le client
 */
export const cancelOrderAdvantage = (customerId, orderId) => ({
  type: actionTypes.CANCEL_ORDER_ADVANTAGE,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/customers/${customerId}/orders/${orderId}/advantage/cancel.json`,
    method: "POST",
    body: {},
  },
});